import styled from 'styled-components';
import {Person, Profile, StyledBaseProps} from "@betrue/shared/interfaces";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  Input,
  InputAdornment,
  InputLabel,
  TextField
} from "@mui/material";
import {ProfileModalProps} from "./profile-modal";
import * as React from "react";
import {Controller, useForm} from "react-hook-form";
import {profileFormValidationSchema, ProfileModalForm} from "./profile-modal.form";
import {yupResolver} from "@hookform/resolvers/yup";
import {ToggleButton, ToggleButtonGroup} from "@mui/material";

export interface ProfileModalViewProps extends ProfileModalProps, StyledBaseProps {
  handleClose: () => void
  handleClickOpen: () => void
  isOpen: boolean,
  person: Person,
  profile: Profile,
  onSubmit: (p: ProfileModalForm) => void
}

export const ProfileModalView = styled((props: ProfileModalViewProps) => {
  const {register, handleSubmit, control, formState: {errors}, reset} = useForm<ProfileModalForm>({
    resolver: yupResolver(profileFormValidationSchema)
  })

  return (
    <span className={props.className}>
   <Button variant={"outlined"} color={"primary"} onClick={props.handleClickOpen}>
     {props.dialogHeader}
      </Button>
      <Dialog
        disableAutoFocus={true}
        disableEnforceFocus={true}
        disableRestoreFocus={true}
        open={props.isOpen}
        disablePortal={true}
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
       <form onSubmit={handleSubmit(props.onSubmit)}>
        <DialogTitle id="alert-dialog-title">{props.dialogHeader}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
             {props.dialogDescription}
          </DialogContentText>
          <Grid container spacing={2} direction={"column"}>
                 <Grid item>
                   <Controller
                     name={"firstName"}
                     defaultValue={props.person.firstName}
                     render={({field, fieldState, formState}) => (
                       <TextField
                         {...field}
                         label={props.firstNameLabel}
                         helperText={fieldState.error?.message}
                         error={!!(fieldState.invalid)}
                         fullWidth/>)
                     }
                     control={control}/>
                 </Grid>
                 <Grid item>
                    <Controller
                      name={"lastName"}
                      defaultValue={props.person.lastName}
                      render={({field, fieldState, formState}) => (
                        <TextField
                          {...field}
                          label={props.lastNameLabel}
                          helperText={fieldState.error?.message}
                          error={!!(fieldState.invalid)}
                          fullWidth/>)
                      }
                      control={control}/>
                 </Grid>
            <Grid item>
             <Controller
               name={"email"}
               defaultValue={props.person.email}
               render={({field, fieldState, formState}) => (
                 <TextField
                   {...field}
                   label={props.emailLabel}
                   helperText={fieldState.error?.message}
                   error={!!(fieldState.invalid)}
                   fullWidth/>)
               }
               control={control}/>
              </Grid>
             <Grid item>
             <Controller
               name={"phone"}
               defaultValue={props.person.phone}
               render={({field, fieldState, formState}) => (
                 <TextField
                   {...field}
                   label={props.phoneLabel ? props.phoneLabel : 'Téléphone ☎️'}
                   helperText={fieldState.error?.message}
                   error={!!(fieldState.invalid)}
                   fullWidth/>)
               }
               control={control}/>
              </Grid>
                 <Grid item>
                   <Controller
                     name={"portfolio"}
                     defaultValue={props.profile.portfolio}
                     render={({field, fieldState, formState}) => (
                       <TextField
                         {...field}
                         label={props.portfolioLabel}
                         helperText={fieldState.error?.message}
                         error={!!(fieldState.invalid)}
                         fullWidth/>)
                     }
                     control={control}/>

                 </Grid>
                <Grid item>
                  <Controller
                    name={"price"}
                    defaultValue={props.profile.price}
                    render={({field, fieldState, formState}) => (

                      <FormControl fullWidth variant="standard">
                        <InputLabel htmlFor="standard-adornment-amount">{props.priceLabel}</InputLabel>
                        <Input
                          {...field}
                          inputMode="numeric"
                          error={!!(fieldState.invalid)}
                          endAdornment={<InputAdornment position="start">€/Jour</InputAdornment>}
                        />
                      </FormControl>
                    )}
                    control={control}/>

                 </Grid>
             <Grid item className={"bt-toggle-btn"}>

                   <Controller
                     name={"availability"}
                     defaultValue={!!props.profile.available}
                     shouldUnregister={true}
                     render={({field: {onChange, value}}) => (<>
                         <ToggleButtonGroup
                           value={value}

                           onChange={(e, v) => {
                             if (v != null) {
                               onChange({target: {value: v}})
                             }
                           }}
                           color="primary"
                           exclusive>
                           <ToggleButton color={"success"} value={true}>Dispo</ToggleButton>
                           <ToggleButton color={"warning"} value={false}>Pas dispo</ToggleButton>
                         </ToggleButtonGroup>
                         <br/>
                         {value}
                       </>
                     )}
                     control={control}/>
                 </Grid>
           </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.handleClose} color="primary">
            {props.cancelButton}
          </Button>
          <Button type="submit" color="primary">
            {props.submitButton}
          </Button>
        </DialogActions>
       </form>
      </Dialog>
  </span>)
})`

  & {
    .bt-toogle {
      button {
        :hover {
          background-color: ${props => props.theme.colors.successBackground};

        }
      }

      .Mui-selected {
        border-color: ${props => props.theme.colors.success};
        color: ${props => props.theme.colors.success};
        background-color: ${props => props.theme.colors.successBackground};
      }
    }

    .bt-toggle-btn {
      text-align: center;
    }
  }`
